import React, { useRef, useEffect } from "react";
import { HeroArea } from "../../components/heroArea";

import { DevOps } from "../../assets/expertise";
import { useTranslation } from "react-i18next";
import "./expertise.css";
export const Devops = () => {
  const { t } = useTranslation();
  const section = useRef(null);
  useEffect(() => {
    section.current.scrollIntoView();
  }, []);
  return (
    <>
      <HeroArea />

      <div ref={section} className="service--container container">
        <h2>{t("service.devops.title1")}</h2>
        <div className="service--content">
          <p className="paragraph">{t("service.devops.paragraph1")}</p>
          <img src={DevOps} alt="devops" className="service--img" />
        </div>
        <br />
        <div className="service--second--content">
          <h3>{t("service.methodology")}</h3>
          <h4>1 - {t("service.devops.title2")}</h4>
          <p className="paragraph">{t("service.devops.paragraph2")}</p>
          <h4>2 - {t("service.devops.title3")}</h4>
          <p className="paragraph">{t("service.devops.paragraph3")}</p>
          <h4>3 - {t("service.devops.title4")}</h4>
          <p className="paragraph">{t("service.devops.paragraph4")}</p>
          <h4>4 - {t("service.devops.title5")}</h4>
          <p className="paragraph">{t("service.devops.paragraph5")}</p>
          <h4>5 - {t("service.devops.title6")}</h4>
          <p className="paragraph">{t("service.devops.paragraph6")}</p>
        </div>
      </div>
    </>
  );
};
